import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Footer from "../footer";
import BackToTop from "../BackToTop";
import { LuMail } from "react-icons/lu";
import { GrLocation } from "react-icons/gr";

const ContactPage = () => {


  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}, []);


  const [formData, setFormData] = useState({
    fullName: "",
    // lastName: '',
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let formErrors = {};

    if (!formData.fullName.trim()) {
      formErrors.fullName = "Your Name is required";
    }

    if (!formData.email) {
      formErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      formErrors.email = "Email is invalid";
    }

    if (!formData.phoneNumber) {
      formErrors.phoneNumber = "Phone Number is required";
    } else if (!/^\d+$/.test(formData.phoneNumber)) {
      formErrors.phoneNumber = "Phone Number must be numeric";
    }

    // if (!formData.lastName.trim()) {
    //   formErrors.lastName = 'Last Name is required';
    // }

    // if (!formData.message.trim()) {
    //   formErrors.message = 'Message is required';
    // }

    return formErrors;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length === 0) {
      // Form is valid, submit the form

      // Construct the WhatsApp message
      const whatsappMessage = `FirstName: ${formData.fullName}\nLastName: ${formData.lastName}\nEmail: ${formData.email}\nMessage: ${formData.message}`;

      // WhatsApp URL with the encoded message
      const whatsappURL = `https://api.whatsapp.com/send?phone=9003383786&text=${encodeURIComponent(
        whatsappMessage
      )}`;

      // Open WhatsApp with the pre-filled message
      window.open(whatsappURL, "_blank");

      // Optionally, clear the form after submission
      setFormData({
        fullName: "",
        // lastName: '',
        email: "",
        message: "",
      });
    } else {
      setErrors(formErrors);
    }
  };
  return (
    <section>
      <Navbar />
      <section className="relative py-20 md:py-[120px] " data-aos="fade-up" data-aos-duration="3000">
        <div className="absolute top-0 left-0 -z-[1] w-full h-full"></div>
        <div className="absolute top-0 left-0 -z-[1] h-1/2 w-full bg-[#ccddf7] bg-[url('D:\yogesh_aluminium\aluminium\src\assets\images\others\aluminium_fabri.webp')] brightness-50  lg:h-[45%] xl:h-1/2"></div>
        <div className="container mx-auto ">
          <div className="flex flex-wrap items-center ">
            <div className="w-full px-4 lg:w-7/12 xl:w-8/12">
              <div className="ud-contact-content-wrapper">
                <div className="ud-contact-title mb-12 lg:mb-[150px]">
                  <span className="block mb-6 text-base font-semibold text-neutral-50">
                    CONTACT US
                  </span>
                  <h2 className="max-w-[300px] text-[35px] leading-[1.14] text-blue-50 font-semibold">
                    Let's talk Feel Free.
                  </h2>
                </div>
                <div className="flex flex-wrap justify-between mb-12 lg:mb-0 text-[#fafdff] lg:text-black">
                  <div className="mb-8 flex w-[330px] max-w-full ">
                    <div className="mr-6 text-[32px] lg:text-blue-950">
                    <GrLocation />
                     
                    </div>
                    <div>
                      <h5 className="mb-[18px] text-lg font-semibold ">
                        Our Location
                      </h5>
                      <p className="text-base ">
                        14C, Bye Pass Road, East Sengulam, Thirumangalam,
                        Madurai - 625 706.
                      </p>
                      <p className="mt-2">
                        <b>Office Hours:</b> Monday to Saturday, 9 Am - 7 Pm.
                      </p>
                    </div>
                  </div>
                  <div className="mb-8 flex w-[330px] max-w-full">
                    <div className="mr-6 text-[32px] lg:text-blue-950">
                    <LuMail />
                      </div>
                    <div>
                      <h5 className="mb-[18px] text-lg font-semibold">
                        How Can We Help?
                      </h5>

                      <a
                        href="mailto:yogeshaluminium@gmail.com"
                        target="_blank"
                        className="text-base"
                      >
                        yogeshaluminium@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full px-4 lg:w-5/12 xl:w-4/12 ">
              <div
                className="wow fadeInUp rounded-lg bg-[#fafdff]  py-10 px-8 shadow-lg  sm:py-12 sm:px-10 md:p-[60px] lg:p-10 lg:py-12 lg:px-10 2xl:p-[60px]"
                data-wow-delay=".2s
                "
              >
                <h3 className="mb-8 text-2xl font-semibold md:text-[28px] md:leading-[1.42] ">
                  Send us a Message
                </h3>

                <form onSubmit={handleSubmit}>
                  <div className="mb-[22px]">
                    <label
                      for="fullName"
                      className="block mb-4 text-sm "
                    >
                      Full Name*
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Enter Your Name"
                      className={`${
                        errors.fullName
                          ? "border-red-500 focus:border-red-500"
                          : "focus:border-blue-900 ]"
                      } bg-transparent w-full border-0 border-b border-[#e4e3e3] pb-3 focus:outline-none`}
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                    {errors.fullName && (
                      <p className="text-xs text-red-500">{errors.fullName}</p>
                    )}
                  </div>

                  <div className="mb-[22px]">
                    <label
                      for="email"
                      className="block mb-4 text-sm "
                    >
                      Email*
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="example@yourmail.com"
                      className={`${
                        errors.email
                          ? "border-red-500 focus:border-red-500"
                          : "focus:border-blue-900 "
                      }bg-transparent w-full border-0 border-b border-[#e4e3e3] pb-3 focus:outline-none`}
                      value={formData.email}
                      onChange={handleChange}
                    />

                    {errors.email && (
                      <p className="text-xs text-red-500">{errors.email}</p>
                    )}
                  </div>
                  <div className="mb-[22px]">
                    <label
                      for="phone"
                      className="block mb-4 text-sm text-body-color dark:text-dark-6"
                    >
                      Phone*
                    </label>
                    <input
                      type="text"
                      placeholder="+885 1254 5211 552"
                      className={`${
                        errors.phoneNumber
                          ? "border-red-500 focus:border-red-500"
                          : "focus:border-blue-900 "
                      }bg-transparent w-full  border-0 border-b border-[#e4e3e3]  pb-3 focus:outline-none`}
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                    />
                    {errors.phoneNumber && (
                      <p className="text-xs text-red-500">
                        {errors.phoneNumber}
                      </p>
                    )}
                  </div>
                  <div className="mb-[30px]">
                    <label
                      for="message"
                      className="block mb-4 text-sm text-body-color dark:text-dark-6"
                    >
                      Message*
                    </label>
                    <textarea
                      name="message"
                      rows="1"
                      placeholder="type your message here"
                      className="bg-transparent w-full  resize-none border-0 border-b border-[#e4e3e3] focus:border-blue-900 pb-3  focus:outline-none"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="mb-0">
                    <button
                      type="submit"
                      className="inline-flex items-center justify-center px-10 py-3 text-base font-medium text-white transition duration-300 ease-in-out rounded-md bg-blue-900 hover:bg-blue-dark"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1000">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d374.3095219229549!2d77.9765057!3d9.8327435!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00d2584ba16359%3A0x89419a91e706b6cb!2sRXMG%2B3HG%2C%20Urappanur%2C%20Tamil%20Nadu%20625706!5e1!3m2!1sen!2sin!4v1717746576205!5m2!1sen!2sin"
          width="100%"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <Footer />

      <BackToTop />
    </section>
  );
};

export default ContactPage;
